function jsonEqual(left, right) {
  if (Array.isArray(left) !== Array.isArray(right)) return false
  if (Array.isArray(left) && Array.isArray(right)) return left.length === right.length && left.every((value, index) => jsonEqual(value, right[index]))
  if (left && right && typeof left === 'object' && typeof right === 'object') {
    const keys = Object.keys(left)
    return keys.length === Object.keys(right).length && keys.every(key => Object.prototype.hasOwnProperty.call(right, key) && jsonEqual(left[key], right[key]))
  }
  return left === right
}

export function applySurveyConditions(fieldDefinitions, answers, baseValues = {}) {
  const fields = JSON.parse(JSON.stringify(fieldDefinitions || []))
  const answerValues = new Map((answers || []).map(answer => [answer.name, answer.value]))

  fields.forEach(field => {
    if (!("enabled" in field)) field.enabled = true
    if (!("display" in field)) field.display = true

    ;(field.conditions || []).forEach(condition => {
      const answer = answerValues.has(condition.field)
        ? answerValues.get(condition.field)
        : baseValues[condition.field]
      let valueToCheck = answer

      if (condition.comparator === 'property_equals') {
        const source = fields.find(item => item.name === condition.field)
        const selectedChoice = source && Array.isArray(source.choices)
          ? source.choices.find(choice => jsonEqual(choice.value, answer))
          : null
        if (!selectedChoice) return
        valueToCheck = selectedChoice[condition.property]
      }

      if (condition.comparator !== 'equals' && condition.comparator !== 'property_equals') return
      if (valueToCheck === undefined || !jsonEqual(valueToCheck, condition.value) || !condition.operation) return

      const property = condition.operation.relates_to
      if (condition.operation.type === 'show' && Array.isArray(field[property])) {
        field[property] = field[property].filter((item, index) => condition.operation.indexes.includes(index))
      } else if (condition.operation.type === 'enabled') {
        field[property] = condition.operation.enabled
      }
    })
  })

  return fields.filter(field => field.display)
}
